import { render, staticRenderFns } from "./listaPdv.vue?vue&type=template&id=05ec95ea&scoped=true&"
import script from "./listaPdv.vue?vue&type=script&lang=js&"
export * from "./listaPdv.vue?vue&type=script&lang=js&"
import style0 from "./listaPdv.vue?vue&type=style&index=0&id=05ec95ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ec95ea",
  null
  
)

export default component.exports